 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"slide-edit": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "chunk/slide-" + ({"async~493df0b3":"async~493df0b3","async~c5b24172":"async~c5b24172","async~4ef0f61d":"async~4ef0f61d","async~1aabc013":"async~1aabc013","async~2e2c6527":"async~2e2c6527","async~da8db81f":"async~da8db81f","async~e10030d6":"async~e10030d6","async~098dcb65":"async~098dcb65","async~d0c14fe8":"async~d0c14fe8","async~7f8bedbf":"async~7f8bedbf","async~f40490b4":"async~f40490b4","async~2158e36e":"async~2158e36e","async~207dd19b":"async~207dd19b","async~76acd586":"async~76acd586","async~748942c6":"async~748942c6","async~37d786cf":"async~37d786cf","async~30ccc425":"async~30ccc425","async~8c6c8fa0":"async~8c6c8fa0","async~907e9098":"async~907e9098","async~43172549":"async~43172549","async~e19e9216":"async~e19e9216","async~f19eb79b":"async~f19eb79b","async~c2ea7c3c":"async~c2ea7c3c","async~95108331":"async~95108331","async~7c3032d4":"async~7c3032d4","async~901f7a11":"async~901f7a11","async~718865d2":"async~718865d2","async~89b7a519":"async~89b7a519","dsi-report":"dsi-report","media-container":"media-container","commonAsync~9b1fde68":"commonAsync~9b1fde68","commonAsync~27f19aac":"commonAsync~27f19aac","commonAsync~205ac551":"commonAsync~205ac551","commonAsync~32e631b8":"commonAsync~32e631b8","commonAsync~08369118":"commonAsync~08369118","commonAsync~7daf70e2":"commonAsync~7daf70e2","commonAsync~aa99c80b":"commonAsync~aa99c80b","commonAsync~86c92fed":"commonAsync~86c92fed","commonAsync~30f778ef":"commonAsync~30f778ef","commonAsync~6e568190":"commonAsync~6e568190","commonAsync~54a68610":"commonAsync~54a68610","commonAsync~61b3c105":"commonAsync~61b3c105","commonAsync~f7b3ac00":"commonAsync~f7b3ac00","commonAsync~cece21d6":"commonAsync~cece21d6","commonAsync~c8e963e0":"commonAsync~c8e963e0","commonAsync~8a9fd21a":"commonAsync~8a9fd21a","commonAsync~4eb02325":"commonAsync~4eb02325","commonAsync~957ef72f":"commonAsync~957ef72f","commonAsync~82e96715":"commonAsync~82e96715","commonAsync~6c5dfa7c":"commonAsync~6c5dfa7c","commonAsync~7827d820":"commonAsync~7827d820","commonAsync~3337127f":"commonAsync~3337127f","commonAsync~d2c096c2":"commonAsync~d2c096c2","commonAsync~1285a477":"commonAsync~1285a477","commonAsync~31ded9a0":"commonAsync~31ded9a0","commonAsync~ecdbff9b":"commonAsync~ecdbff9b","commonAsync~4fb44df2":"commonAsync~4fb44df2","commonAsync~d06fe423":"commonAsync~d06fe423","commonAsync~fb219127":"commonAsync~fb219127","commonAsync~0519277e":"commonAsync~0519277e","commonAsync~b5c4f9e4":"commonAsync~b5c4f9e4","commonAsync~74226ea0":"commonAsync~74226ea0","commonAsync~f45d36cf":"commonAsync~f45d36cf","commonAsync~e50ee5dc":"commonAsync~e50ee5dc","commonAsync~b3c4a2ff":"commonAsync~b3c4a2ff","commonAsync~19bb5a55":"commonAsync~19bb5a55","comment-manager":"comment-manager","meetingroom":"meetingroom","player":"player","vendors~chart-component":"vendors~chart-component","vendors~lazyComponents":"vendors~lazyComponents","vendors~select-window":"vendors~select-window","vendors~service":"vendors~service","vendors~slide-sdk-ot-transform":"vendors~slide-sdk-ot-transform","vendors~tencent-meeting":"vendors~tencent-meeting","vendors~bundle_excel-helper":"vendors~bundle_excel-helper","vendors~bundle_slide-helper":"vendors~bundle_slide-helper","vendors~bundle_word-helper":"vendors~bundle_word-helper","pdf-adapter":"pdf-adapter","smartcanvas-adapter":"smartcanvas-adapter","vendors~doc-adapter":"vendors~doc-adapter","vendors~sheet-adapter":"vendors~sheet-adapter","vendors~slide-adapter":"vendors~slide-adapter","vendors~tencent-clipboard":"vendors~tencent-clipboard","lazyComponentsMobile":"lazyComponentsMobile","local-to-sync-doc-button":"local-to-sync-doc-button","vendors~lazySlidePlayer":"vendors~lazySlidePlayer"}[chunkId]||chunkId) + "-" + {"0":"0507af","1":"5b1e70","2":"300a5c","3":"b24112","5":"0d2af2","6":"f58cd3","7":"027187","8":"3f3053","9":"3f5efe","10":"bdbdeb","12":"d52f42","13":"4cabb8","16":"c4a076","17":"4621cf","18":"16f368","19":"d0428b","20":"7884b7","21":"a2fbf1","22":"bfb0bc","23":"ed670d","24":"7d7631","25":"0450d6","26":"2428fb","27":"9b0ed4","28":"00ba77","29":"b96670","30":"de5557","31":"b31fbb","32":"09ee95","33":"0ec8f4","34":"dbfa94","35":"bd76b1","36":"551a01","async~493df0b3":"694d18","async~c5b24172":"84686b","async~4ef0f61d":"cf38f7","async~1aabc013":"b34a7e","async~2e2c6527":"5a1893","async~da8db81f":"fd6800","async~e10030d6":"ecad62","async~098dcb65":"02289d","async~d0c14fe8":"2be112","async~7f8bedbf":"6e531d","async~f40490b4":"d3af68","async~2158e36e":"21b04b","async~207dd19b":"5718c0","async~76acd586":"b673a7","async~748942c6":"520949","async~37d786cf":"2a3b3f","async~30ccc425":"7f46db","async~8c6c8fa0":"8899a1","async~907e9098":"869fec","async~43172549":"16c0af","async~e19e9216":"612d7b","async~f19eb79b":"22c6f2","async~c2ea7c3c":"a078ed","async~95108331":"b371f0","async~7c3032d4":"6cbc43","async~901f7a11":"044351","async~718865d2":"2ac8d4","async~89b7a519":"9e7bbe","dsi-report":"700160","media-container":"95a510","commonAsync~9b1fde68":"5e418e","commonAsync~27f19aac":"24b69c","commonAsync~205ac551":"c1fef5","commonAsync~32e631b8":"d082d5","commonAsync~08369118":"a88389","commonAsync~7daf70e2":"4869e2","commonAsync~aa99c80b":"84ef9e","commonAsync~86c92fed":"414d6e","commonAsync~30f778ef":"ae8617","commonAsync~6e568190":"c7ae15","commonAsync~54a68610":"62a954","commonAsync~61b3c105":"b66ed0","commonAsync~f7b3ac00":"95a4e9","commonAsync~cece21d6":"cb084b","commonAsync~c8e963e0":"db624c","commonAsync~8a9fd21a":"8211a4","commonAsync~4eb02325":"1579a0","commonAsync~957ef72f":"3ec095","commonAsync~82e96715":"d70ae5","commonAsync~6c5dfa7c":"ce831d","commonAsync~7827d820":"c6f590","commonAsync~3337127f":"604c72","commonAsync~d2c096c2":"043f1e","commonAsync~1285a477":"32a72d","commonAsync~31ded9a0":"3be217","commonAsync~ecdbff9b":"b8f5d9","commonAsync~4fb44df2":"3aa68c","commonAsync~d06fe423":"0fb432","commonAsync~fb219127":"8d93fd","commonAsync~0519277e":"f7d56c","commonAsync~b5c4f9e4":"66257e","commonAsync~74226ea0":"4d8048","commonAsync~f45d36cf":"83d4bf","commonAsync~e50ee5dc":"a9f215","commonAsync~b3c4a2ff":"815fca","commonAsync~19bb5a55":"12d350","comment-manager":"cfbeed","meetingroom":"08a99f","player":"72a9e7","vendors~chart-component":"94c45f","vendors~lazyComponents":"e684cd","vendors~select-window":"8ad063","vendors~service":"c12e4f","vendors~slide-sdk-ot-transform":"996e30","vendors~tencent-meeting":"f1d408","vendors~bundle_excel-helper":"b375b7","vendors~bundle_slide-helper":"694418","vendors~bundle_word-helper":"8fc2a6","pdf-adapter":"744d9a","smartcanvas-adapter":"5bb2fc","vendors~doc-adapter":"8e1e5b","vendors~sheet-adapter":"c0d276","vendors~slide-adapter":"b91a99","vendors~tencent-clipboard":"3b9095","lazyComponentsMobile":"5a15f4","local-to-sync-doc-button":"027790","vendors~lazySlidePlayer":"f175d1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var error = new Error();
 				var onScriptLoadFailed = function (event) {
 				  var chunk = installedChunks[chunkId];
 				  if (chunk !== 0) {
 				    if (chunk) {
 				      var errorType = event && event.type;
 				      var realSrc = event && event.target && event.target.src;
 				      error.message =
 				        "Load chunk " +
 				        chunkId +
 				        " failed.\n(" +
 				        errorType +
 				        ": " +
 				        realSrc +
 				        ")";
 				      chunk[1](error);
 				    }
 				    installedChunks[chunkId] = undefined;
 				  }
 				};

 				var script;
 				if (!window.DCR || !window.DCR.loadScript) {
 				  script = document.createElement("script");
 				  var onScriptComplete;

 				  script.charset = "utf-8";
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute("nonce", __webpack_require__.nc);
 				  }
 				  script.src = jsonpScriptSrc(chunkId);
 				  if (script.src.indexOf(window.location.origin + "/") !== 0) {
 				    script.crossOrigin = "anonymous";
 				  }
 				  // create error before stack unwound to get useful stacktrace later
 				  onScriptComplete = function (event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        var errorType =
 				          event && (event.type === "load" ? "missing" : event.type);
 				        var realSrc = event && event.target && event.target.src;
 				        error.message =
 				          "Loading chunk " +
 				          chunkId +
 				          " failed.\n(" +
 				          errorType +
 				          ": " +
 				          realSrc +
 				          ")";
 				        error.name = "ChunkLoadError";
 				        error.type = errorType;
 				        error.request = realSrc;
 				        chunk[1](error);
 				      }
 				      installedChunks[chunkId] = undefined;
 				    }
 				  };
 				  var timeout = setTimeout(function () {
 				    onScriptComplete({ type: "timeout", target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				} else {
 				  script = window.DCR.loadScript(
 				    {
 				      retryCount: 0,
 				      timeout: 120000,
 				      url: jsonpScriptSrc(chunkId),
 				      nonce: __webpack_require__.nc,
 				      crossOrigin: "anonymous",
 				    },
 				    onScriptLoadFailed
 				  );
 				}
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//docs.gtimg.com/slide/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonp"] = this["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([7,"common~4e144","common~4e727","common~42539","common~6a21b","common~3da57","common~1e529","common~b5d56","common~e53ca","common~c03c9","common~9b312c24","common~2172297d","common~7daf70e2","common~86c92fed","common~c344e93b","common~4791a125","common~7258d1be","common~b79e3e22","common~43881563","common~19ce4402","common~d06fe423","common~03a2c7b3","common~74226ea0","common~112c8377","common~34e3d95a","base~f075b844","base~c5b24172","base~521a7be7","base~37d786cf","base~30ccc425","base~e8378ab1","base~95108331","base~f5b7dd47","base~ab752770","base~54efbb91","base~69fcf6fb","base~0e38129b","base~2de19f54","base~62543e40","base~16e06dc5","base~bc54f~c5b24172","base~bc54f~30ccc425"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
